var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.414 13.8885C12.8556 13.8885 14.0243 12.7198 14.0243 11.2782C14.0243 9.83657 12.8556 8.6679 11.414 8.6679C9.97239 8.6679 8.80371 9.83657 8.80371 11.2782C8.80371 12.7198 9.97239 13.8885 11.414 13.8885Z",
    fill: "#3CAE8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56603 11.2782C6.19172 14.2185 8.83087 15.6287 11.414 15.6287C13.9972 15.6287 16.6363 14.2185 18.262 11.2782C16.6363 8.33794 13.9972 6.9277 11.414 6.9277C8.83087 6.9277 6.19172 8.33794 4.56603 11.2782ZM11.414 5.1875C14.8101 5.1875 18.1453 7.13335 20.0232 10.8891C20.1456 11.134 20.1456 11.4224 20.0232 11.6673C18.1453 15.4231 14.8101 17.3689 11.414 17.3689C8.0179 17.3689 4.68274 15.4231 2.80487 11.6673C2.68239 11.4224 2.68239 11.134 2.80487 10.8891C4.68274 7.13335 8.0179 5.1875 11.414 5.1875Z",
    fill: "#3CAE8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.47caf23f838a500fb74615ad97b6c283.svg";
export { ForwardRef as ReactComponent };